var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "p-5 flex flex-col items-center gap-y-2" },
    [
      _c(
        "div",
        {
          staticClass:
            "w-max border border-blue-400 rounded-xl px-3 bg-white text-sm text-blue-400 leading-6",
        },
        [_vm._t("default")],
        2
      ),
      _vm._l(_vm.users, function (user, i) {
        return _c("RoomCBTInfoItem", { key: i, attrs: { user: user } })
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }